<template>
  <div>
    <b-card
      class="main-card profile-card-border"
    >
      <div class="setting-btn" @click="onClickSetting" v-if="hasSettingBtn">
        <img src="img/svg/VectorNew.svg" />
      </div>
      <div class="text-center">
        <div class="tenantProfile_img">
          <img class="image" :src="imageUrl" />
        </div>
        <h3>
          <span> {{ name }}</span>
        </h3>
        <div>
          <span class="iconss"><i class="fa fa-phone"></i></span
          ><span class="text-dark">{{ phone }}</span>
        </div>
        <div class="mt-1">
          <span class="iconss"><i class="fa fa-envelope"></i></span
          ><span class="text-dark">{{ email }}</span>
        </div>
      </div>
      <div class="mt-3">
        <slot></slot>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "Sourav Samanta",
    },
    email: {
      type: String,
      default: "mail@test.com",
    },
    phone: {
      type: String,
      default: "9609327591",
    },
    hasSettingBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickSetting() {
      this.$emit("clickOnSetting");
    },
  },
};
</script>

<style scoped>
.iconss {
  color: var(--primary);
  margin-right: 5px;
}
.main-card {
  position: relative;
}
.setting-btn {
  cursor: pointer;
  position: absolute;
  top: 1%;
  right: 3%;
}
.setting-btn img {
  width: 21px;
}
.tenantProfile_img {
  width: 80%;
  max-width: 300px;
  aspect-ratio: 1;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  border: 2px solid #4645e7;
  margin: 0 auto;
  margin-bottom: 1rem;
  padding: 0 !important;
  line-height: 0;
  font-size: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tenantProfile_img img {
  width: 100% !important;
  height: 100% !important;
  min-width: 100% !important;
  min-height: 100% !important;
  display: block;
  object-fit: cover !important;
  object-position: center !important;
  border-radius: 50%;
  border: none;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) scale(1.4) !important;
  line-height: 0 !important;
  font-size: 0 !important;
}

.profile-card-border {
  border-radius: 16px;
  border: 1px solid #dee3ea;
}

@media (max-width: 767.98px) {
  .profile-card-border {
    margin-bottom: 1rem;
  }

  .tenantProfile_img {
    width: 70%;
    max-width: 250px;
  }
}

/* Ensure image fills circle completely and touches border */
.tenantProfile_img {
  box-sizing: border-box !important;
}
.tenantProfile_img img {
  box-sizing: border-box !important;
  transform-origin: center center !important;
}
</style>
